(function(){
    angular
        .module('appback')
        .directive('ngCkeditor', ckeditor);

        ckeditor.$inject = ['$timeout'];
        function ckeditor($timeout){
            return {
            require: 'ngModel',
            scope: {
                ngModel:"=",
              autocomplete: "=",
              centro:"="
            },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                    ////console.log(scope);
                    var name = $element.attr("id");
                    var editor

                    function updateModel() {
                        //console.log("UPDATE CKEDITOR");
                        ngModel.$setViewValue(ck.getData());
                        /*$timeout(function(){

                        ck.fire('change');
                        })*/

                        //scope.$apply(function() {
                          //console.log(ck);
                          //console.log(ck.getData());
                            //ngModel.$setViewValue(ck.getData());
                        //});
                    }

                    //console.log(scope);
                    
                     var ck = CKEDITOR.replace(name,{
                        enterMode : CKEDITOR.ENTER_P,
                        toolbar : 'Basic', /* this does the magic */
                    })

                        

                    ck.on( 'instanceReady', function( ev ) {
                        editor = ev.editor;

                        scope.$watch(function() {
                            return element.attr('readonly'); 
                        }, function(newValue){
                            if(newValue){
                                editor.setReadOnly( true );
                            }else{
                                editor.setReadOnly( false );
                            }
                        });
                    });
                     ngModel.$render = function () {
                        var newValue = ngModel.$viewValue;
                        ck.setData(newValue);
                        //console.log(newValue)
                    };

                    /*scope.$watch(scope.ngModel,function () {
                        console.log("WATCH");
                        //return ngModel.$modelValue;
                    }, function(newValue) {
                        console.log("WATCH2");
                        ck.setData(newValue);
                    });*/
                
					          ck.on('change', updateModel);
                    ck.on('key', updateModel);
                    ck.on('dataReady', updateModel);
                    ck.on( 'mode', function() {
                        // Debugger.log('ckeditor mode change: '+ this.mode);
                        if ( this.mode == 'source' ) {
                            var editable = ck.editable();
                            editable.attachListener( editable, 'input', function() {
                                // Debugger.log('ckeditor source input change');
                                 ck.fire('change');
                            } );
                        }
                    } );
                });
            }
          }
      }
})();